import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { APP_NAME } from '../app.config';

const PermissionNotHave = memo(function PermissionNotHave() {
  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box">
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/">{APP_NAME}</Link>
                    </li>
                    {/* <li className="breadcrumb-item active">403 Error</li> */}
                  </ol>
                </div>
                {/* <h4 className="page-title">403 Error</h4> */}
              </div>
            </div>
          </div>

          <div className="row justify-content-center items">
            <div className="col-12">
              <div className="d-flex flex-column h-100">
                <div className="row justify-content-center">
                  <div className="col-lg-4">
                    <div className="text-center">
                      {/* <h1 className="text-error mb-4">403</h1> */}
                      <h2 className="text-uppercase text-danger mt-3">You don't have permission to access this Action</h2>
                      {/* <p className="text-muted mt-3">Please contact the admin to get permission</p> */}

                      <Link className="btn btn-soft-danger mt-3" to="/">
                        <i className="ri-home-4-line me-1"></i> Back to Home
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
});

export default PermissionNotHave;
